export default () => ({
  current: -1,
  toggleOpen() {
    // console.log('toggleOpen');
    // console.log(this.$el.dataset.index);
    if(this.current == this.$el.dataset.index) {
      this.current = -1;
    } else {
      this.current = this.$el.dataset.index;
    }

  },
  // close() {
  //     this.open = false;
  // },
  checkIndex() {
    if(this.$el.dataset.index == this.current) { 
      return true;
    } else {
      return false;
    }
  },
  checkClass() {
    return this.$el.dataset.index == this.current ? 'open' : ''
  }
})